// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__9JxHU","info":"Note_info__3eyPG","note":"Note_note__2UmJC","actions":"Note_actions__3_Oze"};